import React, { Component, Suspense } from 'react';
import PropTypes from 'prop-types';

const Twitter = React.lazy(() => import('./Twitter'));

export default class TwitterWrapper extends Component {
  render() {
    return (
      <div>
        <Suspense>
          <Twitter
            config={this.props.config}
            reportEvent={this.props.reportEvent(this.props.config.universal_id)}
          />
        </Suspense>
      </div>
    );
  }
}

TwitterWrapper.propTypes = {
  config: PropTypes.object.isRequired,
  reportEvent: PropTypes.func,
};
